import React from 'react';
import styled from '@emotion/styled';

import MetronomeEnabledIcon from '../../../assets/icons/metronome-enabled.svg';
import MetronomeDisabledIcon from '../../../assets/icons/metronome-disabled.svg';

interface IMetronomeButton {
  enable?: boolean;
  onClick: () => void;
}

const MetronomeButton: React.FC<IMetronomeButton> = ({ enable = false, onClick }) => {
  return (
    <MetronomeButtonContainer>
      <FieldText
        dangerouslySetInnerHTML={{
          __html: 'Met.',
        }}
      />
      <ButtonContainer onClick={onClick}>
        {enable ? <MetronomeEnabledIcon /> : <MetronomeDisabledIcon />}
      </ButtonContainer>
    </MetronomeButtonContainer>
  );
};

export default MetronomeButton;

const MetronomeButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
`;

const FieldText = styled.span`
  margin-bottom: 11px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.23;
  color: #ffffff;
  height: ${13 * 1.23}px;
  text-align: center;

  @media screen and (max-width: 840px) {
    height: unset;
  }
`;


const ButtonContainer = styled.button`
  width: 50px;
  height: 50px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 0;

  svg {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 840px) {
    margin-top: 0;
    margin-bottom: 5px;
    width: 54px;
    height: 61px;
  }
`;
